import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { MAX_WHOLE_BODY_BYTES } from '../config';
import { PackError, toPackError } from './errors';

/**
 * A random-access, ranged byte source — the browser twin of evidence-cli's
 * ByteSource seam (decision 0041). A remote blob speaking HTTP Range and a
 * local dropped File implement this identically; the zip reader fetches the
 * central directory and then only the entry byte-ranges it needs through it.
 */

var EMPTY = new Uint8Array(0);
var throwIfAborted = function throwIfAborted(signal) {
  if (signal !== null && signal !== void 0 && signal.aborted) throw new PackError('aborted', 'operation aborted');
};

/** A ByteSource over a local File/Blob (drag-drop, file picker). */
export var BlobByteSource = /*#__PURE__*/function () {
  function BlobByteSource(blob) {
    _classCallCheck(this, BlobByteSource);
    this.blob = blob;
  }
  return _createClass(BlobByteSource, [{
    key: "size",
    value: function () {
      var _size = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              throwIfAborted(opts === null || opts === void 0 ? void 0 : opts.signal);
              return _context.abrupt("return", this.blob.size);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function size(_x) {
        return _size.apply(this, arguments);
      }
      return size;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(offset, length, opts) {
        var start, end, _t, _t2;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              throwIfAborted(opts === null || opts === void 0 ? void 0 : opts.signal);
              if (!(length <= 0)) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return", EMPTY);
            case 1:
              start = Math.max(0, Math.min(offset, this.blob.size));
              end = Math.min(start + length, this.blob.size);
              if (!(end <= start)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", EMPTY);
            case 2:
              _t = Uint8Array;
              _context2.next = 3;
              return this.blob.slice(start, end).arrayBuffer();
            case 3:
              _t2 = _context2.sent;
              return _context2.abrupt("return", new _t(_t2));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function read(_x2, _x3, _x4) {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }]);
}();
/**
 * A ByteSource over HTTP(S). Prefers ranged GETs (206). When the server
 * ignores Range and answers 200 with the full body, it degrades gracefully:
 * the body is downloaded once (bounded by maxWholeBodyBytes), kept in memory,
 * and every read becomes a local slice — correctness preserved, selectivity
 * lost. Oversized Range-less packs fail loudly with 'pack-too-large' instead
 * of OOM-killing the tab.
 */
export var HttpByteSource = /*#__PURE__*/function () {
  function HttpByteSource(url, options) {
    var _options$maxWholeBody, _options$fetchImpl, _options$preferWholeB;
    _classCallCheck(this, HttpByteSource);
    _defineProperty(this, "total", null);
    /** Full body cache, only populated when the server ignores Range. */
    _defineProperty(this, "whole", null);
    _defineProperty(this, "warnedNoRange", false);
    this.url = url;
    this.maxWholeBodyBytes = (_options$maxWholeBody = options === null || options === void 0 ? void 0 : options.maxWholeBodyBytes) !== null && _options$maxWholeBody !== void 0 ? _options$maxWholeBody : MAX_WHOLE_BODY_BYTES;
    this.fetchImpl = (_options$fetchImpl = options === null || options === void 0 ? void 0 : options.fetchImpl) !== null && _options$fetchImpl !== void 0 ? _options$fetchImpl : fetch.bind(globalThis);
    this.preferWholeBody = (_options$preferWholeB = options === null || options === void 0 ? void 0 : options.preferWholeBody) !== null && _options$preferWholeB !== void 0 ? _options$preferWholeB : false;
  }
  return _createClass(HttpByteSource, [{
    key: "degraded",
    get: function get() {
      return this.whole !== null;
    }
  }, {
    key: "size",
    value: function () {
      var _size2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(opts) {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.total === null)) {
                _context3.next = 1;
                break;
              }
              _context3.next = 1;
              return this.probe(opts);
            case 1:
              return _context3.abrupt("return", this.total);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function size(_x5) {
        return _size2.apply(this, arguments);
      }
      return size;
    }()
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(offset, length, opts) {
        var total, start, want, res, _t3, _t4;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              throwIfAborted(opts === null || opts === void 0 ? void 0 : opts.signal);
              if (!(length <= 0)) {
                _context4.next = 1;
                break;
              }
              return _context4.abrupt("return", EMPTY);
            case 1:
              if (!(this.whole === null && this.total === null)) {
                _context4.next = 2;
                break;
              }
              _context4.next = 2;
              return this.probe(opts);
            case 2:
              if (!this.whole) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", this.sliceWhole(offset, length));
            case 3:
              total = this.total;
              start = Math.max(0, Math.min(offset, total));
              want = Math.max(0, Math.min(length, total - start));
              if (!(want === 0)) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return", EMPTY);
            case 4:
              _context4.next = 5;
              return this.doFetch({
                headers: {
                  Range: "bytes=".concat(start, "-").concat(start + want - 1)
                },
                signal: opts === null || opts === void 0 ? void 0 : opts.signal
              });
            case 5:
              res = _context4.sent;
              if (!(res.status === 206)) {
                _context4.next = 7;
                break;
              }
              this.rememberTotal(res.headers.get('content-range'));
              _t3 = Uint8Array;
              _context4.next = 6;
              return res.arrayBuffer();
            case 6:
              _t4 = _context4.sent;
              return _context4.abrupt("return", new _t3(_t4));
            case 7:
              if (!(res.status === 200)) {
                _context4.next = 9;
                break;
              }
              _context4.next = 8;
              return this.cacheWhole(res);
            case 8:
              return _context4.abrupt("return", this.sliceWhole(offset, length));
            case 9:
              throw new PackError('http-error', "HTTP ".concat(res.status, " fetching ").concat(this.url), {
                status: res.status,
                url: this.url
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function read(_x6, _x7, _x8) {
        return _read2.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "doFetch",
    value: function () {
      var _doFetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(init) {
        var _t5;
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return this.fetchImpl(this.url, init);
            case 1:
              return _context5.abrupt("return", _context5.sent);
            case 2:
              _context5.prev = 2;
              _t5 = _context5["catch"](0);
              throw toPackError(_t5, 'fetch-failed');
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function doFetch(_x9) {
        return _doFetch.apply(this, arguments);
      }
      return doFetch;
    }()
    /**
     * Learn the total size with a 1-byte ranged GET. A 206 answer gives the
     * total from Content-Range; when that header is unreadable (a blob store's
     * CORS ExposedHeaders often omits it — Azure does) fall back to a HEAD's
     * Content-Length. A 200 answer means no Range support, so the body we were
     * just handed IS the whole source — cache it (bounded).
     */
  }, {
    key: "probe",
    value: (function () {
      var _probe = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(opts) {
        var _res, res;
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.preferWholeBody) {
                _context6.next = 4;
                break;
              }
              _context6.next = 1;
              return this.doFetch({
                signal: opts === null || opts === void 0 ? void 0 : opts.signal
              });
            case 1:
              _res = _context6.sent;
              if (_res.ok) {
                _context6.next = 2;
                break;
              }
              throw new PackError('http-error', "HTTP ".concat(_res.status, " fetching ").concat(this.url), {
                status: _res.status,
                url: this.url
              });
            case 2:
              _context6.next = 3;
              return this.cacheWhole(_res);
            case 3:
              return _context6.abrupt("return");
            case 4:
              _context6.next = 5;
              return this.doFetch({
                headers: {
                  Range: 'bytes=0-0'
                },
                signal: opts === null || opts === void 0 ? void 0 : opts.signal
              });
            case 5:
              res = _context6.sent;
              if (!(res.status === 206)) {
                _context6.next = 9;
                break;
              }
              this.rememberTotal(res.headers.get('content-range'));
              // Drain the 1-byte body so the connection can be reused.
              _context6.next = 6;
              return res.arrayBuffer();
            case 6:
              if (!(this.total === null)) {
                _context6.next = 7;
                break;
              }
              _context6.next = 7;
              return this.probeHead(opts);
            case 7:
              if (!(this.total === null)) {
                _context6.next = 8;
                break;
              }
              throw new PackError('size-unavailable', "cannot size ".concat(this.url, ": Content-Range unreadable (is it in the ") + "host's CORS Access-Control-Expose-Headers?) and HEAD gave no " + "Content-Length", {
                url: this.url
              });
            case 8:
              return _context6.abrupt("return");
            case 9:
              if (!(res.status === 200)) {
                _context6.next = 11;
                break;
              }
              _context6.next = 10;
              return this.cacheWhole(res);
            case 10:
              return _context6.abrupt("return");
            case 11:
              throw new PackError('http-error', "HTTP ".concat(res.status, " fetching ").concat(this.url), {
                status: res.status,
                url: this.url
              });
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function probe(_x0) {
        return _probe.apply(this, arguments);
      }
      return probe;
    }())
  }, {
    key: "probeHead",
    value: function () {
      var _probeHead = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(opts) {
        var res, len, _t6;
        return _regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return this.fetchImpl(this.url, {
                method: 'HEAD',
                signal: opts === null || opts === void 0 ? void 0 : opts.signal
              });
            case 1:
              res = _context7.sent;
              len = res.headers.get('content-length');
              if (res.ok && len !== null && /^\d+$/.test(len)) this.total = Number(len);
              _context7.next = 3;
              break;
            case 2:
              _context7.prev = 2;
              _t6 = _context7["catch"](0);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function probeHead(_x1) {
        return _probeHead.apply(this, arguments);
      }
      return probeHead;
    }()
  }, {
    key: "rememberTotal",
    value: function rememberTotal(contentRange) {
      var m = contentRange && /bytes \d+-\d+\/(\d+)/.exec(contentRange);
      if (m) this.total = Number(m[1]);
    }

    /**
     * Buffer a 200 (Range-ignored) body under a hard ceiling. Streams with a
     * running counter so an unbounded body is cut off the moment it crosses the
     * limit rather than after it has been fully allocated.
     */
  }, {
    key: "cacheWhole",
    value: (function () {
      var _cacheWhole = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(res) {
        var limit, declared, _res$body, _buf, reader, declaredLen, buf, chunks, received, _yield$reader$read, done, value, out, o, _iterator, _step, c, _t7, _t8;
        return _regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              limit = this.maxWholeBodyBytes;
              declared = res.headers.get('content-length');
              if (!(declared && /^\d+$/.test(declared) && Number(declared) > limit)) {
                _context8.next = 1;
                break;
              }
              (_res$body = res.body) === null || _res$body === void 0 || _res$body.cancel();
              throw new PackError('pack-too-large', "pack is ".concat(Number(declared), " bytes and its host ignores Range ") + "requests; refusing to download more than ".concat(limit, " bytes"), {
                size: Number(declared),
                limit: limit
              });
            case 1:
              // No warning when whole-body was ASKED for (gh-artifact) — the
              // degradation message only fits servers that ignored our Range.
              if (!this.warnedNoRange && !this.preferWholeBody) {
                this.warnedNoRange = true;
                console.warn("".concat(this.url, " does not support Range requests \u2014 downloading whole ") + "pack (selective reads disabled)");
              }
              if (res.body) {
                _context8.next = 4;
                break;
              }
              _t7 = Uint8Array;
              _context8.next = 2;
              return res.arrayBuffer();
            case 2:
              _t8 = _context8.sent;
              _buf = new _t7(_t8);
              if (!(_buf.length > limit)) {
                _context8.next = 3;
                break;
              }
              throw new PackError('pack-too-large', 'pack exceeds download limit', {
                size: _buf.length,
                limit: limit
              });
            case 3:
              this.whole = _buf;
              this.total = _buf.length;
              return _context8.abrupt("return");
            case 4:
              reader = res.body.getReader(); // With a declared length, write chunks straight into the final buffer —
              // the chunks-array-then-concat approach transiently doubles peak memory
              // (2x256 MiB at the ceiling), which is exactly what this bounded path is
              // meant to avoid.
              declaredLen = declared && /^\d+$/.test(declared) ? Number(declared) : null;
              buf = declaredLen !== null ? new Uint8Array(declaredLen) : null;
              chunks = [];
              received = 0;
            case 5:
              _context8.next = 6;
              return reader.read();
            case 6:
              _yield$reader$read = _context8.sent;
              done = _yield$reader$read.done;
              value = _yield$reader$read.value;
              if (!done) {
                _context8.next = 7;
                break;
              }
              return _context8.abrupt("continue", 11);
            case 7:
              received += value.byteLength;
              if (!(received > limit)) {
                _context8.next = 9;
                break;
              }
              _context8.next = 8;
              return reader.cancel();
            case 8:
              throw new PackError('pack-too-large', "pack exceeded the ".concat(limit, "-byte download limit on a host without ") + "Range support", {
                limit: limit
              });
            case 9:
              if (buf !== null && received <= buf.length) {
                buf.set(value, received - value.byteLength);
              } else if (buf !== null) {
                // Server sent more than it declared — fall back to chunk collection.
                chunks.push(buf.subarray(0, received - value.byteLength), value);
                buf = null;
              } else {
                chunks.push(value);
              }
            case 10:
              _context8.next = 5;
              break;
            case 11:
              if (buf !== null) {
                this.whole = received === buf.length ? buf : buf.subarray(0, received);
              } else {
                out = new Uint8Array(received);
                o = 0;
                _iterator = _createForOfIteratorHelper(chunks);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    c = _step.value;
                    out.set(c, o);
                    o += c.byteLength;
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                this.whole = out;
              }
              this.total = received;
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function cacheWhole(_x10) {
        return _cacheWhole.apply(this, arguments);
      }
      return cacheWhole;
    }())
  }, {
    key: "sliceWhole",
    value: function sliceWhole(offset, length) {
      var w = this.whole;
      var start = Math.max(0, Math.min(offset, w.length));
      var end = Math.min(start + Math.max(0, length), w.length);
      return w.subarray(start, end);
    }
  }]);
}();